import { render, staticRenderFns } from "./PuestoDependenciaTabContent.vue?vue&type=template&id=c3d3c9ec&scoped=true"
import script from "./PuestoDependenciaTabContent.vue?vue&type=script&lang=js"
export * from "./PuestoDependenciaTabContent.vue?vue&type=script&lang=js"
import style0 from "./PuestoDependenciaTabContent.vue?vue&type=style&index=0&id=c3d3c9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d3c9ec",
  null
  
)

export default component.exports